import { CELL_PADDING, cellAlignClass } from "./helpers";

export default function PatientListTableSkeleton({ columns, rowCount }) {
    return Array.from({ length: rowCount }).map((_, rowIndex) => (
        <tr
            key={rowIndex}
            className="h-16 border-y border-neutral-200 last:border-b-0"
        >
            {columns.map((col) => (
                <td
                    key={col.id}
                    className={`${CELL_PADDING} text-[0px] ${cellAlignClass(col)}`}
                >
                    <div className="inline-block h-4 w-3/4 animate-pulse rounded bg-neutral-200" />
                </td>
            ))}
        </tr>
    ));
}
